<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="aniosDisponibles" [typeFilter]="Filters.YEAR"
    [click]="false"
    (eventClick)="cambioAnio($event)"
  />
  <app-filters filtros
    [name]="'filtros.lider' | translate"
    [array]="responsablesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActas"
    (eventClick)="cambioLider($event)"
  />
  <app-filters filtros
    [name]="'filtros.res' | translate"
    [array]="responsablesActividadesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActiv"
    (eventClick)="cambioResponsable($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}"
    (click)="borrarFiltro()" class="iconoMen" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="contenidoClass">
    <div class="tablaZone">
      <app-contenedor-elementos [header]="{title: ''}" >
        <div iconos *appRoles="permisos.CARGA_ARCHIVOS" class="colorBotonDeNuevo" (click)="modalPlan('nuevo')">
          <mat-icon #add class="iconoMen" matTooltip="{{'gestion.formulacion.proy-estra.agregarProy' | translate}}">add_circle_outline</mat-icon> 
          <label for="add">{{'gestion.formulacion.proy-estra.agregarProy' | translate}}</label>
        </div>
        <div iconos>
          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          <button (click)="exportarExcel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
        </mat-menu>

        <div body class="table">
          @if (!mostabla) {
              <app-skeleton-table [columnas]="12" [filas]="15" />
          }@else {
            <table class="tabla-aleema">
              <thead>
                <tr>
                  <th>
                    @if (mostrarAllActas) {
                      <mat-icon (click)="mostrarTodasLasActas()" class="iconoMen" matTooltip="{{'gestion.formulacion.alta-planes.ocultarTodo' | translate}}" matTooltipPosition="left" >expand_less</mat-icon>
                    }@else {
                      <mat-icon (click)="mostrarTodasLasActas()"  class="iconoMen" matTooltip="{{'gestion.formulacion.alta-planes.mostrarTodo' | translate}}" matTooltipPosition="left" >expand_more</mat-icon>
                    }
                  </th>
                  <th (click)="ordenamientoTabla()" class="anchosColumnas contenedorSort" style="width: 20vw !important;">
                    {{'gestion.formulacion.alta-planes.titTab1' | translate}}
                    @switch (ordenamiento) {
                      @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                      @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                      @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>}
                    }
                  </th>
                  <th class="anchosColumnas">{{'gestion.formulacion.alta-planes.titTab2' | translate}}</th>
                  <th class="anchosColumnas">{{'gestion.formulacion.alta-planes.titTab3' | translate}}</th>
                  <th class="anchosColumnas">{{'gestion.formulacion.alta-planes.titTab4' | translate}}</th>
                  <th class="anchosColumnas">{{'gestion.formulacion.alta-planes.titTab5' | translate}}</th>
                  <th class="th-gantt">
                    <div class="gantt-ruler">
                      @for (mes of meses; track $index) {
                        <div class="gantt-mes-label" [style.width]="getMesWidth(mes)">{{mes.name}}</div>
                      }
                    </div>
                  </th>
                  @if (actasMostrar.length != 0) {
                    @for (ad of adicionales; track ad; let i = $index) {
                      <th [matMenuTriggerFor]="manuEdicionAd">
                        {{ad.name}}
                      </th>
                      <mat-menu class="w3-medium" #manuEdicionAd="matMenu">
                        <button (click)="editarAdicional(ad)" class="mat-menu-item" mat-menu-item>
                          <mat-icon [ngStyle]="{'color':'gray'}">edit</mat-icon>
                          <span>{{'menu.Editar' | translate}}</span>
                        </button>
                        <button (click)="eliminarAdicional(ad)" class="mat-menu-item" mat-menu-item>
                          <mat-icon [ngStyle]="{'color':'gray'}">delete</mat-icon>
                          <span>{{'menu.eliminar' | translate}}</span>
                        </button>
                      </mat-menu>
                    }
                  }
                  <th *appRoles="permisos.CARGA_ARCHIVOS"> 
                    <button matTooltip="Agregar adicional" class="colorBotonDeNuevo" (click)="modalAdicional()">
                      <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                    </button>
                  </th>
                </tr>
              </thead>
              @for (actas of actasMostrar; track actas; let i = $index) {
                <tbody>
                  <tr>
                    <td>
                      @if (actas.check) {
                        <mat-icon class="iconoMen" (click)="mostrarActas(actas)" matTooltip="{{'gestion.formulacion.alta-planes.ocultar' | translate}}" matTooltipPosition="left">expand_less</mat-icon>
                      }@else { 
                        <mat-icon class="iconoMen" (click)="mostrarActas(actas)" matTooltip="{{'gestion.formulacion.alta-planes.mostrar' | translate}}" matTooltipPosition="left">expand_more</mat-icon>
                      }
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="modalActividades('nuevo',actas)" class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon> 
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="modalPlan('editar',actas)" class="iconoMen">edit</mat-icon>
                      <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="eliminarActa(actas)" class="iconoMen">delete</mat-icon> 
                    </td>
                    <td style="font-weight: bold; min-width: 13vw;"
                    [matTooltip]="actas.nombre" [appOverflowTooltip]="actas.nombre">
                      {{actas.nombre}}
                    </td>
                    <td [matTooltip]="actas.responsable.position" [appOverflowTooltip]="actas.responsable.position">{{actas.responsable.position}}</td>
                    <td class="w3-center">{{obtFecha(actas.fecha_ini)}}</td>
                    <td class="w3-center">{{obtDias(actas.fecha_ini,actas.fecha_fin)}}</td>
                    <td class="w3-center">{{obtFecha(actas.fecha_fin)}}</td>
                    <td class="td-gantt">
                      <div class="gantt-track">
                        <div class="gantt-grid-lines"></div>
                        <div [ngClass]="'gantt-bar gantt-bar-plan-'+(i % 4)"
                          [style.left]="getBarLeft(actas.fecha_ini)"
                          [style.width]="getBarWidth(actas.fecha_ini, actas.fecha_fin)">
                        </div>
                      </div>
                    </td>
                    @for (ad of adicionales; track ad; let j = $index) {
                      <td style="min-width: 5vw; max-width: 20vw;">
                        @if (edicionPro(actas,j)) {
                          <div class="alinRight" style="min-width: 3vw; max-width: 10vw;">{{imprimirPro(actas,j)}}</div>
                        }@else {
                          <div style="min-width: 3vw; max-width: 10vw;"><br></div> 
                        }
                      </td>
                    }                 
                    <td><br></td>
                  </tr>
                  @if(actas.check) {
                    @for (act of actas.actividades; track $index) {
                      <tr>
                        <td *appRoles="permisos.CARGA_ARCHIVOS">
                          <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="modalActividades('editar',act)" class="iconoMen w3-button">edit</mat-icon>
                          <mat-icon *appRoles="permisos.CARGA_ARCHIVOS" (click)="eliminarActividad(act)" class="iconoMen w3-button">delete</mat-icon>
                        </td>
                        <td *appRolesNeg="permisos.CARGA_ARCHIVOS"> <br> </td>
                        <td [matTooltip]="act.nombre" [appOverflowTooltip]="act.nombre"> 
                          {{act.nombre}}
                        </td>
                        <td style="min-width: 10vw;"
                        [matTooltip]="act.responsable.position" [appOverflowTooltip]="act.responsable.position">{{act.responsable.position}}</td>
                        <td class="w3-center">{{obtFecha(act.fecha_inicio)}}</td>
                        <td class="w3-center">{{obtDias(act.fecha_inicio,act.fecha_fin)}}</td>
                        <td class="w3-center">{{obtFecha(act.fecha_fin)}}</td>
                        <td class="borderAllLow td-gantt">
                          <div class="gantt-track">
                            <div class="gantt-grid-lines"></div>
                            <div [ngClass]="'gantt-bar gantt-bar-act-'+(i % 4)"
                              [style.left]="getBarLeft(act.fecha_inicio)"
                              [style.width]="getBarWidth(act.fecha_inicio, act.fecha_fin)">
                            </div>
                          </div>
                        </td>
                        @for (ad of adicionales; track ad; let j = $index) {
                          <td style=" min-width: 5vw; max-width: 20vw;">
                            <ng-container  *appRoles="permisos.CARGA_ARCHIVOS">
                              @if (act.adicionales[j].type === 'moneda') {
                                <div (dblclick)="edicionAdicional(act,j)" class="alinRight" style="cursor: pointer;">
                                  {{act.adicionales[j].type==='moneda'?this.formatearnormal(act.adicionales[j].amount):''}}
                                </div>
                              }
                              @if (act.adicionales[j].type === 'numero') {
                                <div (dblclick)="edicionAdicionalN(act,j)" class="alinIzq" style="cursor: pointer;">
                                  {{obtComment(act.adicionales[j].comments)}} <br>
                                </div>
                              }
                            </ng-container>
                            <ng-container  *appRolesNeg="permisos.CARGA_ARCHIVOS">
                              @if(act.adicionales[j].type === 'moneda') {
                                <div class="alinRight"> 
                                  {{act.adicionales[j].type==='moneda'?this.formatearnormal(act.adicionales[j].amount):''}}
                                </div>
                              }
                              @if (act.adicionales[j].type === 'numero') {
                                <div class="alinIzq">{{act.adicionales[j].note}}</div>
                              }
                            </ng-container>
                          </td>
                        }                      
                        <td><br></td>
                      </tr> 
                    } 
                  }
                </tbody>
              }            
            </table>
          }
        </div>
      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>
<!-- Modal para agregar y editar planes -->
<app-modal [isOpen]="modal1" [cerrar]="false" (close)="close_modal('modalPlan')">
  <div modal-header>
    {{ titModal }}
  </div>

  <div modal-body>
    <div class="w3-row" style="width: 95%; margin: 1vh;" [formGroup]="formPlan">
      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoPlan' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input
              type="text"
              class="contentInput"
              formControlName="inputNamePlan"
              placeholder="{{ 'gestion.formulacion.alta-planes.campoPlanTT' | translate }}"
              [matTooltip]="formPlan.controls.inputNamePlan.value" [appOverflowTooltip]="formPlan.controls.inputNamePlan.value"
            />
          </div>
          @if (formPlan.hasError('isValid')) {
          <div class="alinLeft" style="font-size: 8pt; color: red">
            {{ 'gestion.formulacion.alta-planes.nombreExis' | translate }}
          </div>
          }
        </div>
      </div>

      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoDesc' | translate }}
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput" style="height: fit-content;">
            <textarea
              class="contentTextArea"
              formControlName="inputDescripcion"
              rows="3"
              placeholder="{{ 'gestion.formulacion.alta-planes.campoDescTT' | translate }}"
              [matTooltip]="formPlan.controls.inputDescripcion.value" [appOverflowTooltip]="formPlan.controls.inputDescripcion.value"
            ></textarea>
          </div>
        </div>
      </div>

      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoRes' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <select
              class="contentSelect"
              formControlName="inputLider"
              value=""
              [ngClass]="{ 'placeholderSelect': formPlan.controls['inputLider'].value === '' }"
            >
              <option
                value=""
                disabled
                hidden
                selected
                style="color: #b6b6b6 !important;"
              >
                {{ 'gestion.formulacion.alta-planes.campoResTT' | translate }}
              </option>
              @for (opt of responsables; track $index) {
              <option class="textoOverFlow" value="{{ opt.id }}"
              [matTooltip]="opt.nombre" [appOverflowTooltip]="opt.nombre">
                {{ opt.nombre }}
              </option>
              }
            </select>
          </div>
        </div>
      </div>

      <div style="margin-top: 1vh !important; display: none;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoPlan' | translate }}
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input
              type="file"
              class="contentInput"
              id="archivoActa"
              formControlName="inputArchivo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="close_modal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':formPlan.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarActa()"
  />
</app-modal>
<!-- Modal para agregar y editar actividades -->
<app-modal [isOpen]="modal2" [cerrar]="false" (close)="close_modal()">
  <div modal-header>
    {{ titModal }}
  </div>

  <div modal-body>
    <div class="w3-row" style="width: 95%; margin: 1vh;" [formGroup]="formActividad">
      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoAct' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input
              type="text"
              class="contentInput"
              formControlName="inputNameAct"
              placeholder="{{ 'gestion.formulacion.alta-planes.campoActTT' | translate }}"
              [matTooltip]="formActividad.controls.inputNameAct.value" [appOverflowTooltip]="formActividad.controls.inputNameAct.value"
            />
          </div>
        </div>
      </div>

      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoFecIni' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput" style="height: fit-content;">
            <input
              type="date"
              class="contentDate"
              formControlName="inputFechaIn"
              [value]="fechaAct"
              [min]="minDate"
              [max]="maxDate"
              style="width: 100%;"
              placeholder="{{ 'gestion.formulacion.ind-metas.campoFecIniTT' | translate }}"
            />
          </div>
        </div>
      </div>

      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoFecFin' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput" style="height: fit-content;">
            <input
              type="date"
              class="contentDate"
              formControlName="inputFechaFn"
              [value]="fechaAct"
              [min]="formActividad.controls['inputFechaIn'].value"
              [max]="maxDate"
              style="width: 100%;"
              placeholder="{{ 'gestion.formulacion.ind-metas.campoFecIniTT' | translate }}"
            />
          </div>
        </div>
      </div>

      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs">
              {{ 'gestion.formulacion.alta-planes.campoRes' | translate }} *
            </span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <select
              class="contentSelect"
              formControlName="inputLider"
              value=""
              [ngClass]="{ 'placeholderSelect': formActividad.controls['inputLider'].value === '' }"
            >
              <option
                value=""
                disabled
                hidden
                selected
                style="color: #b6b6b6 !important;"
              >
                {{ 'gestion.formulacion.alta-planes.campoResTT' | translate }}
              </option>
              @for (opt of responsables; track $index) {
              <option class="textoOverFlow" value="{{ opt.id }}"
              [matTooltip]="opt.nombre" [appOverflowTooltip]="opt.nombre">
                {{ opt.nombre }}
              </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="close_modal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':formActividad.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarActividades()"
  />
</app-modal>
<!-- Modal para agregar adicional -->
<app-modal [isOpen]="modal3" [cerrar]="false" (close)="close_modal()">
  <div modal-header>
    {{titModal}}
  </div>

  <div modal-body>
    <div class="w3-row" style="padding-right: 1.5vw;" [formGroup]="formAdicional">     
      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.alta-planes.campoAdicional' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input type="text" class="contentInput" style="min-width: 18vw;" formControlName="inputName" placeholder="{{'gestion.formulacion.alta-planes.campoAdicionalTT' | translate}}"
            [matTooltip]="formAdicional.controls.inputName.value" [appOverflowTooltip]="formAdicional.controls.inputName.value">
          </div>
          @if(formAdicional.hasError('isValid')){
            <div class="alinLeft"  style="font-size: 8pt; color: red">{{'gestion.formulacion.alta-planes.nombreExis'|translate}}</div>
          }            
        </div>
      </div>
      <div style="margin-top: 1vh !important;">
        <div class="texto">
          <div class="w3-right zonaTexto2">
            <span class="w3-right textoInputs"> {{'gestion.formulacion.alta-planes.campoTipoAdicional' | translate}} *</span>
          </div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <select class="contentSelect" formControlName="inputType" style="min-width: 18vw;" value="" [ngClass]="{'placeholderSelect': formAdicional.controls['inputType'].value === ''}">
              <option value="" disabled hidden selected style="color: #b6b6b6 !important;"> {{'gestion.formulacion.alta-planes.campoTipoAdicionalTT' | translate}} </option>
              <option value="texto" matTooltip="{{'gestion.formulacion.alta-planes.tipoTextoTT' | translate}}"> {{'gestion.formulacion.alta-planes.tipoTexto' | translate}} </option>
              <option value="moneda" matTooltip="{{'gestion.formulacion.alta-planes.tipoMonedaTT' | translate}}"> {{'gestion.formulacion.alta-planes.tipoMoneda' | translate}} </option>
              <option value="archivo" matTooltip="{{'gestion.formulacion.alta-planes.tipoArchTT' | translate}}"> {{'gestion.formulacion.alta-planes.tipoArch' | translate}} </option>
              <option value="numero" matTooltip="{{'gestion.formulacion.alta-planes.tipoTextoFijoTT' | translate}}"> {{'gestion.formulacion.alta-planes.tipoTextoFijo' | translate}} </option>               
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="close_modal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled':formAdicional.invalid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardarAdi()"
  />
</app-modal>